import React, {useEffect, useRef} from 'react';
import OneMessageDisplaying from './OneMessageDisplaying';
import NewMessageForm from './NewMessageForm';
import UserListing from './UserListing';
import getOperators from './liveChatRequest/liveChatGetOperators';
import getComList from './liveChatRequest/liveChatGetComList';
import getActiveCom from './liveChatRequest/liveChatGetActiveCom';
import './liveChatStyle/livechat.css';

export default function LiveChatAdmin(props) {

  const comRefreshing = useRef(null);
  const oneComInterval = useRef(null);

  useEffect (() => {  // console.log('>>>>> operatorlist = ', props.state)
    if (props.state.operator_list.length === 0) {
      getOperators(props.dispatch);
    }
    if (props.state.active_operator_id !== 0) {
          clearInterval(comRefreshing.current);
          comRefreshing.current = setInterval(() => {
            getComList(props.state, props.dispatch);
          }, 4000);
    }
    if (props.state.operator_list.length > 0
        && (props.state.active_operator_id !== props.state.current_operator_id
        || props.state.active_operator_id !== 0)) {
          clearInterval(oneComInterval.current);
          oneComInterval.current = null;
          props.dispatch({
            type: 'change_current_operator_id',
            payload: {current_operator_id: props.state.active_operator_id}});
          getComList(props.state, props.dispatch);
          props.dispatch({
            type: 'change_active_communication',
            payload: {active_communication: []}
          });
    }
 
    return;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.state.operator_list, props.state.active_operator_id])

  return (
    <div  className="live_chat_container" id="scroll_style">
      <div className="hotline_menu">
        <div>
          {props.state && (<p>{'Bonjour ' + props.state.active_operator_name}</p>)}
        </div>
        <UserListing
          state={props.state}
          dispatch={props.dispatch}
          oneComInterval={oneComInterval} />
      </div>
      <div className="display_communication">
        {props.state.current_communication !== ''
          && props.state.active_communication.length > 0 && (
          <>
            <div className="comTitle">
              <span className="comTitleSpan">
                {'Communication de ' + props.state.current_communication + ', '
                  + (props.state.com_offset) + ' derniers messages'}
              </span>
              <br></br>
              <label>Nombre de messages que vous consultez = </label>
              <input 
                type="range" name="limit" min="0" max="50"
                className="comLimit"
                value={props.state.com_offset}
                onChange={(e) => {
                  props.dispatch({
                    type: 'change_com_offset',
                    payload: {com_offset: e.target.value}})
                    clearInterval(oneComInterval.current);
                    oneComInterval.current =
                      setInterval(() => 
                          getActiveCom(props.state, props.state.chat_id, props.dispatch),
                          3000,
                      );
                }} />
            </div>
            <ul>
              {props.state.active_communication.map((item, index) => (
                <OneMessageDisplaying 
                  key={"comnb" + index}
                  item={item}
                  state={props.state}
                  dispatch={props.dispatch}
                  index={index}
                  setComList={props.setComList}
                  pseudo={props.pseudo} 

                  />
              ))}
              <NewMessageForm 
                state={props.state}
                dispatch={props.dispatch}
                // comList={props.comList}
                // setComList={props.setComList}
                // pseudo={props.pseudo} 

                />
            </ul>
          </>
        )}
      </div>
    </div>
  )
}
